import SendInvitation from "../../components/SendInvitation";
import React, { useCallback, useEffect, useState } from "react";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { useI18n } from "../../hooks/i18n-hooks";
import { useSnackbar } from "../../hooks/snackbar";
import VStack from "../../ui_atoms/VStack";
import ScreenCard from "../ScreenCard";
import { ButtonProps } from "../../components/Button";

type SendInvitationScreenProps = StackScreenProps<RootStackParamList, "SendInvitation">;

const SendInvitationScreen = ({ navigation, route }: SendInvitationScreenProps) => {
    const { target, invitationId } = route.params || {};
    const i18n = useI18n();
    const { showSnackbar } = useSnackbar();
    const onSuccess = useCallback(() => {
        showSnackbar({
            text: i18n.t(`invitation.action_result.sent.success`),
            mode: "success",
        });
        navigation.pop();
    }, [i18n, navigation, showSnackbar]);

    const [buttonProps, setButtonProps] = useState<Partial<ButtonProps>[]>();

    useEffect(() => {
        navigation.setOptions({ title: i18n.t(`invitation.send.${target}.title`) });
    }, [i18n, navigation, target]);

    return (
        <ScreenCard
            buttons={
                !invitationId
                    ? [
                          {
                              title: i18n.t("invitation.send.sendButton"),
                              buttonMode: "secondary",
                              size: "large",
                              ...buttonProps?.[0],
                          },
                      ]
                    : [
                          {
                              label: i18n.t("invitation.action.cancel"),
                              buttonMode: "outlined",
                              size: "medium",
                              ...buttonProps?.[0],
                          },
                          {
                              title: i18n.t("invitation.send.resendButton"),
                              buttonMode: "secondary",
                              size: "large",
                              ...buttonProps?.[1],
                          },
                      ]
            }
        >
            <VStack h={1 / 2}>
                <SendInvitation
                    target={target}
                    invitationId={invitationId}
                    onSuccess={onSuccess}
                    setButtonProps={setButtonProps}
                />
            </VStack>
        </ScreenCard>
    );
};

export default SendInvitationScreen;
